import { getMockDataPromise } from "../../helpers/GlobalHelper";

const getMockLoans = async () => {
  const mockData = [
    {
      id: "78f1b827-135c-43a5-a250-36e13fc089f8",
      createdBy: "brooke@builders-capital.com",
      createdOn: "1/15/2021 5:15PM",
      updatedBy: "catherine.quinn@builders-capital.com",
      submittedDate: "01/15/2021",
      applicationNo: 2008016,
      loanNo: 71723,
      loanPhase: "Servicing",
      borrower: "Black Oak Homes & Design Inc.",
      specialPurposeEntity: "",
      projectName: "10142 Beckham St (Lot 55)",
      loanStatus: "Active",
      loanSubStatus: "NA",
      loanProgram: "New Construction",
      loanAmountOriginal: "$472,798.56",
      loanAmountCurrent: "$157,428.56",
      estimatedClosingDate: "08/14/2020",
      maturityDateCurrent: "08/14/2020",
      owner: "Global",
      fund: "BCF",
      loanOfficer: "Rod Manson",
      portfolioManager: "Tiffany Coldewy",
      outOfPocketBC: "$120,692.37",
      mostRecentComment: "Please uncheck Direct Pay",
      bridgetoBuildPhase: "Phase I"
    },
    {
      id: "55f1b827-135c-43a5-a250-36e13fc089f8",
      createdBy: "catherine.quinn@builders-capital.com",
      createdOn: "1/15/2021 5:15PM",
      updatedBy: "catherine.quinn@builders-capital.com",
      submittedDate: "01/15/2021",
      applicationNo: 2008016,
      loanNo: 71723,
      loanPhase: "Servicing",
      borrower: "Black Oak Homes & Design Inc.",
      specialPurposeEntity: "",
      projectName: "10142 Beckham St (Lot 55)",
      loanStatus: "Active",
      loanSubStatus: "NA",
      loanProgram: "New Construction",
      loanAmountOriginal: "$472,798.56",
      loanAmountCurrent: "$157,428.56",
      estimatedClosingDate: "08/14/2020",
      maturityDateCurrent: "08/14/2020",
      owner: "Global",
      fund: "BCF",
      loanOfficer: "Rod Manson",
      portfolioManager: "Tiffany Coldewy",
      outOfPocketBC: "$120,692.37",
      mostRecentComment: "Please uncheck Direct Pay",
      bridgetoBuildPhase: "Phase I"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoan = async () => {
  const mockData = {
    summary: {
      id: "78f1b827-135c-43a5-a250-36e13fc089f8",
      name: "Lokal Builders",
      property: "Market Street Condos",
      address: "1234 Main Street",
      city: "Seattle",
      state: "WA",
      loanAmount: 5000000,
      closing: "11/30/2020",
      completeness: 0.12,
      tags: [
        {
          type: "tc",
          value: "Danae"
        },
        {
          type: "lo",
          value: "Rob"
        }
      ]
    },
    documents: [
      {
        address: "1234 Main Street",
        city: "Seattle",
        state: "WA",
        zip: 98103,
        parcelNumber: 98103,
        lotNumber: 1,
        zoning: "Residential",
        existingStructure: "Land",
        newStructure: "SFR",
        currentWorkStage: "No work started",
        units: []
      },
      {
        address: "1234 Main Street",
        city: "Seattle",
        state: "WA",
        zip: 98103,
        parcelNumber: 98103,
        lotNumber: 2,
        zoning: "Residential",
        existingStructure: "Land",
        newStructure: "SFR",
        currentWorkStage: "No work started",
        units: []
      }
    ]
  };

  return getMockDataPromise(mockData);
};

const getMockLoanApplications = async () => {
  const mockData = [
    {
      "Id": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "Name": "8A6850D31372",
      "Borrower_OrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "Borrower_Organization": "A85D2098FC1E",
      "CityId": "8a990c65-8bc7-4c0a-8025-23b94fd4f36a",
      "City": "Tucson",
      "CountyId": "64131ba8-f84d-4c5d-bc5a-fcdb4b0348f6",
      "County": "Pima",
      "Jurisdiction": "",
      "PartneredLoan": false,
      "StateId": "e271eac5-6d34-45ec-8cde-73b30b360a70",
      "State": "Arizona",
      "Street": "9FAF27BC32F3",
      "Zip": "00646",
      "Builder_OrganizationId": "c0fce01f-d4f4-4544-954f-945187c0004b",
      "Builder": "25D5AEA79C2A",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanProgramId": "10dadf83-86e1-4f82-b86a-454824397dce",
      "LoanProgram": "All In One",
      "EstimatedConstructionBudget": 3780000,
      "LoanNumber": "72341",
      "NumberOfUnits": 9,
      "TermOfLoan": 0,
      "Description": "",
      "CreatedOn": "2021-08-28T14:44:10.057",
      "CreatedBy": "catherine.quinn@builders-capital.com",
      "UpdatedOn": "2022-01-21T10:24:38.793",
      "UpdatedBy": "deleted",
      "LockVersion": 58,
      "AmountRequiredAtClosing": "",
      "AdditionalMortgage": "",
      "ApplicationNumber": "2108105",
      "FilterLoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "FilterOrganizationCSVId": ",5BB945DE-8DAC-4B02-BC5F-506176672A25,",
      "CopyId": "No",
      "LoanPhaseId": "b2250162-e2bb-4030-8946-a648005cf083",
      "LoanStatusId": "153da1a9-0324-449f-abdf-ad56001e14dd",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "LockedBy_UserAccountId": "",
      "SubmittedDate": "2021-08-30T15:05:50.663",
      "CriticalConditions": "Critical Conditions",
      "Fund": "",
      "Owner": "Builders Capital",
      "Frozen": "No",
      "Master_LoanId": "",
      "WireAmount": 1185928.75,
      "EstimatedClosingDate": "2021-09-30T00:00:00",
      "PortfolioManager": "Tiffany Coldewey",
      "LoanOfficer": "Josh Cormany",
      "LoanSubStatus": "Lost",
      "LoanPhaseLoanStatusDisplayId": "Production - Processing - Lost",
      "LockedBy": "",
      "LoanSubType": "Purchase",
      "Origin": "Borrower Portal",
      "HasBroker": "No",
      "FilterLoanOfficer_OrganizationContactCSVId": ",0F85CDD2-10C3-4749-B368-AC5B00FA96D6,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    },
    {
      "Id": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "Name": "7E71746C223D",
      "Borrower_OrganizationId": "3c5b73af-5c7a-488c-8bbc-248e0a4fbc55",
      "Borrower_Organization": "B8901FB7D290",
      "CityId": "65f8ceab-037c-4973-abd0-1ab27218a25b",
      "City": "Blythe",
      "CountyId": "bf917cfa-f0f9-41db-b1c1-f10f1b2b4614",
      "County": "Riverside",
      "Jurisdiction": "Riverside",
      "PartneredLoan": false,
      "StateId": "9681cddd-3deb-44a4-ba46-a158625afad2",
      "State": "California",
      "Street": "F9153C976714",
      "Zip": "00646",
      "Builder_OrganizationId": "1ebd5199-c925-4b51-bd0e-adba00d78164",
      "Builder": "1E887CB0DB54",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanProgramId": "10dadf83-86e1-4f82-b86a-454824397dce",
      "LoanProgram": "All In One",
      "EstimatedConstructionBudget": 1500000,
      "LoanNumber": "72417",
      "NumberOfUnits": 10,
      "TermOfLoan": 0,
      "Description": "",
      "CreatedOn": "2021-10-01T16:31:27.07",
      "CreatedBy": "brooke@builders-capital.com",
      "UpdatedOn": "2021-11-05T08:49:18.94",
      "UpdatedBy": "deleted",
      "LockVersion": 29,
      "AmountRequiredAtClosing": "",
      "AdditionalMortgage": "",
      "ApplicationNumber": "2110003",
      "FilterLoanId": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "FilterOrganizationCSVId": ",3C5B73AF-5C7A-488C-8BBC-248E0A4FBC55,",
      "CopyId": "No",
      "LoanPhaseId": "b2250162-e2bb-4030-8946-a648005cf083",
      "LoanStatusId": "6e98fee7-ed8e-4c47-84f2-ad56001db3df",
      "LoanPhase": "Production",
      "LoanStatus": "UW Restructure",
      "LockedBy_UserAccountId": "",
      "SubmittedDate": "2021-10-11T19:50:21.64",
      "CriticalConditions": "Critical Conditions",
      "Fund": "",
      "Owner": "Builders Capital",
      "Frozen": "No",
      "Master_LoanId": "",
      "WireAmount": -49637.24,
      "EstimatedClosingDate": "2021-10-29T00:00:00",
      "PortfolioManager": "Sarah Litts",
      "LoanOfficer": "Jacob Wolbach",
      "LoanSubStatus": "Sales",
      "LoanPhaseLoanStatusDisplayId": "Production - UW Restructure - Sales",
      "LockedBy": "",
      "LoanSubType": "Purchase",
      "Origin": "Borrower Portal",
      "HasBroker": "No",
      "FilterLoanOfficer_OrganizationContactCSVId": ",BF8B0038-8833-46D8-B355-AA1600B1DBEE,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanApplicationsInfo = async () => {
  const mockData = [{
    "Id": "942288ca-ee8b-4665-96bb-bb5af1097fb1",
    "ProjectName": "DADDEC260C5A",
    "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
    "BridgeToBuildPhaseId": "",
    "BridgeToBuildPhase": "",
    "InterestCalculationMethodId": "ec78d260-e03f-4b13-8a28-a644001d8c2a",
    "InterestCalculationMethod": "Principal",
    "LoanProgram": "New Construction",
    "LoanSubTypeId": "c472f9a5-5409-4f04-927c-a64400fe7bc0",
    "LoanSubType": "Refi-External",
    "AdditionalCollateralDescription": "",
    "DirectPay": false,
    "ForcedDraw": false,
    "InterestRateOriginal": 8,
    "InterestReserveOriginal": 573051.96,
    "LoanAmountOriginal": 7565983.71,
    "MaturityDateOriginal": "2023-08-07T00:00:00",
    "Phase1Term": "",
    "UseInterestReserve": true,
    "Description": "",
    "CreatedOn": "2021-08-16T12:24:48.26",
    "CreatedBy": "deleted",
    "UpdatedOn": "2021-12-08T10:39:54.227",
    "UpdatedBy": "deleted",
    "LockVersion": 3,
    "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
    "ApplicationNumber": "2108060",
    "LoanNumber": "72333",
    "LoanStatus": "Processing",
    "LoanPhase": "Production",
    "LoanSubStatus": "2nd Review",
    "LoanPhaseLoanStatusDisplayId": "Production - Processing - 2nd Review",
    "SubmittedDate": "2021-08-25T15:38:00.223",
    "Borrower_Organization": "E79893E5B34E",
    "SpecialPurposeEntity": "",
    "CriticalConditions": "Critical Conditions",
    "FilterOrganizationCSVId": ",C1F585DB-4948-465D-B83E-AD8600C8A7A1,",
    "Fund": "",
    "Estimated1DrawDate": "",
    "EstimatedPayoffDate": "",
    "EstimatedConstructionCompletionDate": "",
    "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
    "SortOrder": 2023,
    "OWNER": "Builders Capital",
    "PurchaseDate": "",
    "Modification": "No",
    "WatchList": "No",
    "PreviousLoans": "",
    "LoanAmountCurrent": "",
    "BudgetRemaining": 4928053.2,
    "MaturityDateCurrent": "2023-08-07T00:00:00",
    "LoanOfficer": "Rich D'Agostino",
    "PortfolioManager": "Brittney Battrick",
    "TitleNumber": "deleted",
    "ParcelNumbers": "deleted,deleted",
    "ROFRValue": 378299.19,
    "ROFR": "Yes",
    "InterestRateCurrent": 0,
    "Frozen": "No",
    "WireAmount": 2235809.16,
    "OutOfPocketBC": "",
    "EstimatedClosingDate": "2022-01-21T00:00:00",
    "OverrideDrawPreventions": "No",
    "Counties": "Arecibo",
    "States": "NV",
    "Zips": "00612",
    "RecordingNumber": "",
    "MostRecentComment": "deleted",
    "EscrowPay": "No",
    "WireDate": "",
    "LoanClosedDate": "",
    "Origin": "",
    "HasBroker": "Yes",
    "FilterLoanOfficer_OrganizationContactCSVId": ",1E02B32B-43BA-4CA8-B4FD-A67A011C0B6C,13082E46-5685-4E77-9BFA-A6E100552120,13082E46-5685-4E77-9BFA-A6E100552120,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
  },
    {
      "Id": "d458ab87-3702-406d-8110-34438222faac",
      "ProjectName": "C3250167EA4D",
      "LoanId": "348c5575-3b71-4284-b5e6-86c1111bcffb",
      "BridgeToBuildPhaseId": "",
      "BridgeToBuildPhase": "",
      "InterestCalculationMethodId": "ec78d260-e03f-4b13-8a28-a644001d8c2a",
      "InterestCalculationMethod": "Principal",
      "LoanProgram": "New Construction",
      "LoanSubTypeId": "ac989ae4-3078-4878-a929-a64400fe55fb",
      "LoanSubType": "Purchase",
      "AdditionalCollateralDescription": "",
      "DirectPay": false,
      "ForcedDraw": false,
      "InterestRateOriginal": 8.49,
      "InterestReserveOriginal": 242170.53,
      "LoanAmountOriginal": 4679998.18,
      "MaturityDateOriginal": "",
      "Phase1Term": "",
      "UseInterestReserve": true,
      "Description": "",
      "CreatedOn": "2021-10-11T18:38:18.82",
      "CreatedBy": "",
      "UpdatedOn": "2021-10-27T06:10:38.993",
      "UpdatedBy": "deleted",
      "LockVersion": 1,
      "FilterLoanId": "348c5575-3b71-4284-b5e6-86c1111bcffb",
      "ApplicationNumber": "2110032",
      "LoanNumber": "72436",
      "LoanStatus": "Processing",
      "LoanPhase": "Production",
      "LoanSubStatus": "2nd Review",
      "LoanPhaseLoanStatusDisplayId": "Production - Processing - 2nd Review",
      "SubmittedDate": "2021-10-15T08:09:52.93",
      "Borrower_Organization": "D6073D21B681",
      "SpecialPurposeEntity": "",
      "CriticalConditions": "Critical Conditions",
      "FilterOrganizationCSVId": ",1ED7E4A3-1B3D-450A-9707-979C1DCAC602,",
      "Fund": "",
      "Estimated1DrawDate": "",
      "EstimatedPayoffDate": "",
      "EstimatedConstructionCompletionDate": "",
      "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
      "SortOrder": 2023,
      "OWNER": "Builders Capital",
      "PurchaseDate": "",
      "Modification": "No",
      "WatchList": "No",
      "PreviousLoans": "",
      "LoanAmountCurrent": "",
      "BudgetRemaining": 3500100,
      "MaturityDateCurrent": "",
      "LoanOfficer": "Jacob Wolbach",
      "PortfolioManager": "Tiffany Coldewey",
      "TitleNumber": "",
      "ParcelNumbers": "deleted,deleted,deleted,deleted",
      "ROFRValue": "",
      "ROFR": "No",
      "InterestRateCurrent": 0,
      "Frozen": "No",
      "WireAmount": 805690.7,
      "OutOfPocketBC": "",
      "EstimatedClosingDate": "2021-10-29T00:00:00",
      "OverrideDrawPreventions": "No",
      "Counties": "Arecibo",
      "States": "WA",
      "Zips": "00612",
      "RecordingNumber": "",
      "MostRecentComment": "deleted",
      "EscrowPay": "No",
      "WireDate": "",
      "LoanClosedDate": "",
      "Origin": "Borrower Portal",
      "HasBroker": "No",
      "FilterLoanOfficer_OrganizationContactCSVId": ",BF8B0038-8833-46D8-B355-AA1600B1DBEE,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }];

  return getMockDataPromise(mockData);
};

const getMockLoanApplicationsProperty = async () => {
  const mockData = [
    {
      "Id": "08d40627-4755-43f0-9bd2-1710a675cd04",
      "CityId": "65f8ceab-037c-4973-abd0-1ab27218a25b",
      "City": "Blythe",
      "CollateralProperty": false,
      "LoanId": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "LotAppraisedValue": "",
      "LotNumber": "deleted",
      "ParcelNumber": "deleted",
      "PlanNumber": "",
      "StateId": "9681cddd-3deb-44a4-ba46-a158625afad2",
      "State": "California",
      "Street": "7E5E8A8988F0",
      "SubordinateFinancingAmount": 0,
      "TaxPercentRate": 0,
      "Zip": "00612",
      "Description": "",
      "CreatedOn": "2021-10-01T16:31:27.07",
      "CreatedBy": "",
      "UpdatedOn": "2021-10-31T19:18:57.54",
      "UpdatedBy": "deleted",
      "LockVersion": 4,
      "PurchasedPrice": 49000,
      "DownPayment": -11994.9,
      "LotValue": 0,
      "MortgagePayout": "",
      "LoanBudgetId": "4b90ed98-8e37-4e5b-aec7-b534d533f10d",
      "SpecialPurposeEntity": "",
      "PropertyTypeId": "cec284dd-8fba-48d6-a0ee-a63c00cd08ec",
      "PropertyType": "No structure, Land",
      "LoanSubType": "Purchase",
      "LoanProgram": "All In One",
      "FilterLoanId": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "FilterOrganizationId": "3c5b73af-5c7a-488c-8bbc-248e0a4fbc55",
      "Borrower_Organization": "B8901FB7D290",
      "Name": "7E71746C223D",
      "ApplicationNumber": "2110003",
      "LoanNumber": "72417",
      "COODate": "",
      "Fund": "",
      "County": "Riverside",
      "Budget": 1956500,
      "OriginalPurchasePrice": "",
      "OutOfPocket": 0,
      "DisbursedAmount": 0,
      "NWCCProject": "Not Sent",
      "NumberOfUnits": 1,
      "PermitStatusId": "3591db95-8374-4e9a-9dc7-a64400fe12f1",
      "PermitStatus": "Issued",
      "OwnedOrPurchased": "LandToPurchase",
      "TPValuationDate": "",
      "TPValuationProviderId": "",
      "TPValuationProvider": "",
      "FloodZoneId": "",
      "FloodZone": "",
      "ReadyForNWCC": false,
      "NWCCProjectId": "",
      "AutoDrawSetup": "No",
      "NeedsBorrowerApprovalBeforeSubmit": "No",
      "LoanPhase": "Production",
      "LoanStatus": "UW Restructure",
      "NWCCProjectNo": "",
      "PortfolioManager": "Sarah Litts",
      "IsBudgetFrozenYesNo": "No",
      "BudgetFrozenOn": "",
      "LoanSubStatus": "Sales",
      "LoanPhaseLoanStatusDisplayId": "Production - UW Restructure - Sales",
      "BudgetPercentComplete": 0,
      "AllUnitsPaidYesNo": "No",
      "LastestConstructionPhase": "",
      "DrawMgmt": "Draw Mgmt",
      "WorkInspectionCompany_OrganizationId": "",
      "LastInspectionCompanyUsed": "",
      "InspectionCompany": "",
      "PermitIssuedTiming": "",
      "PayoffStrategy": "Sell",
      "PayoffStrategyDescription": "",
      "Zoning": "",
      "NewPropertyType": "Single Family",
      "WorkStage": "Work Not Started",
      "EscrowReferenceNumber": "",
      "EscrowPay": "No",
      "Insurance": "Details",
      "CostBySquareFootage": 1300,
      "NextAutoDrawScheduleDate": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",BF8B0038-8833-46D8-B355-AA1600B1DBEE,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D",
      "AdditionalCollateralDOTNumber": "",
      "AdditionalCollateralDOTRecorded": false,
      "ConvertedToNewPropertyOn": "",
      "ColorId": ""
    },
    {
      "Id": "31454ce3-bc40-4697-af8d-7bee689be66d",
      "CityId": "65f8ceab-037c-4973-abd0-1ab27218a25b",
      "City": "Blythe",
      "CollateralProperty": false,
      "LoanId": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "LotAppraisedValue": "",
      "LotNumber": "deleted",
      "ParcelNumber": "deleted",
      "PlanNumber": "",
      "StateId": "9681cddd-3deb-44a4-ba46-a158625afad2",
      "State": "California",
      "Street": "C6208594ECD7",
      "SubordinateFinancingAmount": 0,
      "TaxPercentRate": 0,
      "Zip": "00612",
      "Description": "",
      "CreatedOn": "2021-10-01T16:31:27.07",
      "CreatedBy": "",
      "UpdatedOn": "2021-10-31T19:03:52.307",
      "UpdatedBy": "deleted",
      "LockVersion": 1,
      "PurchasedPrice": 49000,
      "DownPayment": -11994.91,
      "LotValue": 0,
      "MortgagePayout": "",
      "LoanBudgetId": "",
      "SpecialPurposeEntity": "",
      "PropertyTypeId": "cec284dd-8fba-48d6-a0ee-a63c00cd08ec",
      "PropertyType": "No structure, Land",
      "LoanSubType": "Purchase",
      "LoanProgram": "All In One",
      "FilterLoanId": "285d58c5-2338-4c74-8f97-00c18d0111b2",
      "FilterOrganizationId": "3c5b73af-5c7a-488c-8bbc-248e0a4fbc55",
      "Borrower_Organization": "B8901FB7D290",
      "Name": "7E71746C223D",
      "ApplicationNumber": "2110003",
      "LoanNumber": "72417",
      "COODate": "",
      "Fund": "",
      "County": "Riverside",
      "Budget": "",
      "OriginalPurchasePrice": "",
      "OutOfPocket": 0,
      "DisbursedAmount": "",
      "NWCCProject": "Not Sent",
      "NumberOfUnits": 1,
      "PermitStatusId": "3591db95-8374-4e9a-9dc7-a64400fe12f1",
      "PermitStatus": "Issued",
      "OwnedOrPurchased": "LandToPurchase",
      "TPValuationDate": "",
      "TPValuationProviderId": "",
      "TPValuationProvider": "",
      "FloodZoneId": "",
      "FloodZone": "",
      "ReadyForNWCC": false,
      "NWCCProjectId": "",
      "AutoDrawSetup": "No",
      "NeedsBorrowerApprovalBeforeSubmit": "No",
      "LoanPhase": "Production",
      "LoanStatus": "UW Restructure",
      "NWCCProjectNo": "",
      "PortfolioManager": "Sarah Litts",
      "IsBudgetFrozenYesNo": "No",
      "BudgetFrozenOn": "",
      "LoanSubStatus": "Sales",
      "LoanPhaseLoanStatusDisplayId": "Production - UW Restructure - Sales",
      "BudgetPercentComplete": 0,
      "AllUnitsPaidYesNo": "No",
      "LastestConstructionPhase": "",
      "DrawMgmt": "Draw Mgmt",
      "WorkInspectionCompany_OrganizationId": "",
      "LastInspectionCompanyUsed": "",
      "InspectionCompany": "",
      "PermitIssuedTiming": "",
      "PayoffStrategy": "Sell",
      "PayoffStrategyDescription": "",
      "Zoning": "",
      "NewPropertyType": "Single Family",
      "WorkStage": "Work Not Started",
      "EscrowReferenceNumber": "",
      "EscrowPay": "No",
      "Insurance": "Details",
      "CostBySquareFootage": "",
      "NextAutoDrawScheduleDate": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",BF8B0038-8833-46D8-B355-AA1600B1DBEE,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D",
      "AdditionalCollateralDOTNumber": "",
      "AdditionalCollateralDOTRecorded": false,
      "ConvertedToNewPropertyOn": "",
      "ColorId": ""
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanApplicationsEntities = async () => {
  const mockData = [
    {
      "Id": "b3819883-2511-43c9-bfa1-1043b4fbd55e",
      "Description": "",
      "CreatedOn": "2021-08-28T14:44:10.057",
      "CreatedBy": "",
      "UpdatedOn": "2021-08-28T14:44:10.057",
      "UpdatedBy": "",
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "OrganizationId": "",
      "SpecialPurposeEntityId": "",
      "Role": "Courtesy Reminders",
      "ProjectName": "8A6850D31372",
      "Organization": "",
      "OrganizationContactId": "1170e0f6-1367-4d1c-ab0c-5b3e485e763e",
      "OrganizationContact": "9B2446140538 651F126EA3EE",
      "ApplicationNumber": "2108105",
      "FilterLoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "FilterOrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "LoanNumber": "72341",
      "DetailEntered": "NA",
      "DetailEnteredColorId": "",
      "PreferredContactMethodOption": "",
      "BusinessRoles": "",
      "Borrower_Organization": "A85D2098FC1E",
      "SpecialPurposeEntity": "",
      "EntityOption": "Loan",
      "Fund": "",
      "Email": "E17EDEBBC810@builders-capital.comold",
      "OfficePhone": "67",
      "AffiliatedLoan": "",
      "GuarantyOption": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",0F85CDD2-10C3-4749-B368-AC5B00FA96D6,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    },
    {
      "Id": "34e34d5e-3342-4da3-a0e2-70342d8e2d0c",
      "Description": "",
      "CreatedOn": "2021-08-28T14:44:10.057",
      "CreatedBy": "",
      "UpdatedOn": "2021-08-28T14:44:10.057",
      "UpdatedBy": "",
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "OrganizationId": "c0fce01f-d4f4-4544-954f-945187c0004b",
      "SpecialPurposeEntityId": "",
      "Role": "Builder",
      "ProjectName": "8A6850D31372",
      "Organization": "25D5AEA79C2A",
      "OrganizationContactId": "",
      "OrganizationContact": "",
      "ApplicationNumber": "2108105",
      "FilterLoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "FilterOrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "LoanNumber": "72341",
      "DetailEntered": "NA",
      "DetailEnteredColorId": "",
      "PreferredContactMethodOption": "",
      "BusinessRoles": "",
      "Borrower_Organization": "A85D2098FC1E",
      "SpecialPurposeEntity": "",
      "EntityOption": "Loan",
      "Fund": "",
      "Email": "",
      "OfficePhone": "",
      "AffiliatedLoan": "",
      "GuarantyOption": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",0F85CDD2-10C3-4749-B368-AC5B00FA96D6,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanApplicationsComments = async () => {
  const mockData = [
    {
      "Id": "3d85fb79-6583-4396-b18e-2e8e21899535",
      "Borrower_OrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "Borrower": "A85D2098FC1E",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "LoanNumber": "72341",
      "CommentCategoryId": "770c774e-0d8a-43e3-8452-ad750053ce1a",
      "Category": "Status Change",
      "Subject": "Status Change",
      "OldCategory": "",
      "OldSubject": "",
      "Description": "deleted",
      "CreatedOn": "2021-09-21T09:03:04.053",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-21T09:03:04.053",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "GenerateEmail": false,
      "FilterLoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "FilterOrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "Name": "8A6850D31372",
      "ApplicationNumber": "2108105",
      "ShowToNonLoanCompanyId": false,
      "Fund": "",
      "LoanDrawId": "",
      "PayoffRequestVersionNumber": "",
      "CommentCategorySubjectDisplayId": "Status Change - Status Change"
    },
    {
      "Id": "0f4452d4-2750-432e-a54a-ada8008ff1d7",
      "Borrower_OrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "Borrower": "A85D2098FC1E",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "LoanNumber": "72341",
      "CommentCategoryId": "c07e3f86-cf44-44b3-8df8-3900be34448c",
      "Category": "Production",
      "Subject": "LRC / Fund Polling",
      "OldCategory": "",
      "OldSubject": "",
      "Description": "deleted",
      "CreatedOn": "2021-09-19T08:44:05.26",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-19T08:44:05.26",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "GenerateEmail": false,
      "FilterLoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "FilterOrganizationId": "5bb945de-8dac-4b02-bc5f-506176672a25",
      "Name": "8A6850D31372",
      "ApplicationNumber": "2108105",
      "ShowToNonLoanCompanyId": false,
      "Fund": "",
      "LoanDrawId": "",
      "PayoffRequestVersionNumber": "",
      "CommentCategorySubjectDisplayId": "Production - LRC / Fund Polling"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanApplicationsCondition = async () => {
  const mockData = [
    {
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "Id": "a93bae0b-1e4a-424b-99c6-019aa56696da",
      "LoanNumber": "72341",
      "ApplicationNumber": "2108105",
      "Borrower_Organization": "A85D2098FC1E",
      "IsAutoAddedYesNo": "Yes",
      "EscrowInstruction": false,
      "ConditionStatus": "Received ",
      "ConditionTiming": "CO - Prior to Fund",
      "Description": "deleted",
      "PortfolioManager": "Tiffany Coldewey",
      "LoanOfficer": "Josh Cormany",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "LoanSubStatus": "Lost",
      "ProjectName": "8A6850D31372",
      "CreatedOn": "2021-08-31T07:53:28.067",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-03T11:15:49.29",
      "UpdatedBy": "deleted",
      "ConditionStatusId": "d9b9be0a-7eb4-4bd0-8b1c-acf4001b771b",
      "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
      "Reason": "deleted",
      "Region": "Retail Channel",
      "Closer": "",
      "LoanProgram": "All In One",
      "LoanSubType": "Purchase",
      "CreditAnalyst": "Mike Capenos",
      "LoanPhaseLoanStatusDisplay": "Production - Processing - Lost",
      "FilterLoanOfficer_OrganizationContactCSVId": ",0F85CDD2-10C3-4749-B368-AC5B00FA96D6,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    },
    {
      "LoanId": "26942888-ceca-44a3-a7cc-0033e7a51cf4",
      "Id": "88f3edb1-a96c-4777-831b-04c0618c9a2c",
      "LoanNumber": "72341",
      "ApplicationNumber": "2108105",
      "Borrower_Organization": "A85D2098FC1E",
      "IsAutoAddedYesNo": "Yes",
      "EscrowInstruction": true,
      "ConditionStatus": "Open",
      "ConditionTiming": "CO - Prior to Fund",
      "Description": "deleted",
      "PortfolioManager": "Tiffany Coldewey",
      "LoanOfficer": "Josh Cormany",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "LoanSubStatus": "Lost",
      "ProjectName": "8A6850D31372",
      "CreatedOn": "2021-08-31T07:53:28.067",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-08-31T07:53:28.067",
      "UpdatedBy": "deleted",
      "ConditionStatusId": "244fae56-1f02-4ff1-990b-acf4001b254a",
      "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
      "Reason": "",
      "Region": "Retail Channel",
      "Closer": "",
      "LoanProgram": "All In One",
      "LoanSubType": "Purchase",
      "CreditAnalyst": "Mike Capenos",
      "LoanPhaseLoanStatusDisplay": "Production - Processing - Lost",
      "FilterLoanOfficer_OrganizationContactCSVId": ",0F85CDD2-10C3-4749-B368-AC5B00FA96D6,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }
  ];

  return getMockDataPromise(mockData);
};

const getLoanStatusHistory = () => {
  const mockData = {
    "success": true,
    "LoanStatusHistoryHtml": "<table class=\"htmlData\"><tr><th>Phase</th><th>Status</th><th>Sub Status</th><th>Date</th><th>UpdatedBy</th><th>Comment</th></tr><tr><td>Production</td><td>Application</td><td>Active</td><td>Oct 11 2021  6:38 PM</td><td/><td/></tr><tr><td>Production</td><td>Prescreener</td><td>Active</td><td>Oct 15 2021  8:09 AM</td><td>katie.gerasimas@builders-capital.com</td><td/></tr><tr><td>Production</td><td>Underwriting</td><td>Active</td><td>Oct 15 2021 12:09 PM</td><td>aundraya.miller@builders-capital.com</td><td/></tr><tr><td>Production</td><td>LRC Voting</td><td>Full UW</td><td>Oct 22 2021  2:59 PM</td><td>shana.ma@builders-capital.com</td><td/></tr><tr><td>Production</td><td>Processing</td><td>2nd Review</td><td>Oct 27 2021  6:10 AM</td><td>shana.ma@builders-capital.com</td><td>All Funds have approved the Application with conditions</td></tr>"
  };

  return getMockDataPromise(mockData);
};

const getLoanDetailsPropertyData = () => {
  const mockData = () => [
    {
      "Id": "c70139ee-b6e8-4e1e-a091-ad9700a0a2d6",
      "CityId": "c3f0476c-8f35-46f3-888d-ace6f67ea596",
      "City": "Carson City",
      "CollateralProperty": true,
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "LotAppraisedValue": "",
      "LotNumber": "deleted",
      "ParcelNumber": "deleted",
      "PlanNumber": "",
      "StateId": "39b27a9c-d66a-4131-a781-b2f1be0958ea",
      "State": "Nevada",
      "Street": "C30BE3E34178",
      "SubordinateFinancingAmount": 0,
      "TaxPercentRate": 0,
      "Zip": "00612",
      "Description": "",
      "CreatedOn": "2021-09-02T09:44:51.597",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-12-06T15:06:00.5",
      "UpdatedBy": "deleted",
      "LockVersion": 6,
      "PurchasedPrice": 0,
      "DownPayment": 0,
      "LotValue": 480000,
      "MortgagePayout": "",
      "LoanBudgetId": "",
      "SpecialPurposeEntity": "",
      "PropertyTypeId": "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
      "PropertyType": "Condo",
      "LoanSubType": "Refi-External",
      "LoanProgram": "New Construction",
      "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Borrower_Organization": "E79893E5B34E",
      "Name": "DADDEC260C5A",
      "ApplicationNumber": "2108060",
      "LoanNumber": "72333",
      "COODate": "",
      "Fund": "",
      "County": "Carson City",
      "Budget": "",
      "OriginalPurchasePrice": "",
      "OutOfPocket": 0,
      "DisbursedAmount": "",
      "NWCCProject": "Not Sent",
      "NumberOfUnits": 1,
      "OwnedOrPurchased": "LandOwned",
      "TPValuationDate": "2021-10-18T00:00:00",
      "TPValuationProviderId": "89be63df-19ad-47e1-84e4-aaa000aeea12",
      "TPValuationProvider": "52E23AEAFE72",
      "FloodZoneId": "",
      "FloodZone": "",
      "ReadyForNWCC": false,
      "NWCCProjectId": "",
      "AutoDrawSetup": "No",
      "NeedsBorrowerApprovalBeforeSubmit": "No",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "NWCCProjectNo": "",
      "PortfolioManager": "Brittney Battrick",
      "IsBudgetFrozenYesNo": "No",
      "BudgetFrozenOn": "",
      "LoanSubStatus": "2nd Review",
      "LoanPhaseLoanStatusDisplayId": "Production - Processing - 2nd Review",
      "BudgetPercentComplete": 0,
      "AllUnitsPaidYesNo": "No",
      "LastestConstructionPhase": "",
      "DrawMgmt": "Draw Mgmt",
      "WorkInspectionCompany_OrganizationId": "",
      "LastInspectionCompanyUsed": "",
      "InspectionCompany": "",
      "PayoffStrategy": "",
      "PayoffStrategyDescription": "",
      "Zoning": "",
      "NewPropertyType": "",
      "WorkStage": "",
      "EscrowReferenceNumber": "",
      "EscrowPay": "No",
      "Insurance": "Details",
      "CostBySquareFootage": "",
      "NextAutoDrawScheduleDate": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D",
      "AdditionalCollateralDOTNumber": "",
      "AdditionalCollateralDOTRecorded": false,
      "ConvertedToNewPropertyOn": "",
      "ColorId": ""
    },
    {
      "Id": "6c5fbe56-44f1-46d7-81b0-ad8600cc90f5",
      "CityId": "c3f0476c-8f35-46f3-888d-ace6f67ea596",
      "City": "Carson City",
      "CollateralProperty": false,
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "LotAppraisedValue": "",
      "LotNumber": "deleted",
      "ParcelNumber": "deleted",
      "PlanNumber": "",
      "StateId": "39b27a9c-d66a-4131-a781-b2f1be0958ea",
      "State": "Nevada",
      "Street": "E6D7273A05CE",
      "SubordinateFinancingAmount": 0,
      "TaxPercentRate": 0,
      "Zip": "00612",
      "Description": "",
      "CreatedOn": "2021-08-16T12:24:48.223",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-12-06T15:05:14.293",
      "UpdatedBy": "deleted",
      "LockVersion": 10,
      "PurchasedPrice": 0,
      "DownPayment": 0,
      "LotValue": 2500000,
      "MortgagePayout": 1717979.24,
      "LoanBudgetId": "ed6ba7e0-e0a8-4561-9006-1d865a73dbee",
      "SpecialPurposeEntity": "",
      "PropertyTypeId": "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
      "PropertyType": "Condo",
      "LoanSubType": "Refi-External",
      "LoanProgram": "New Construction",
      "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Borrower_Organization": "E79893E5B34E",
      "Name": "DADDEC260C5A",
      "ApplicationNumber": "2108060",
      "LoanNumber": "72333",
      "COODate": "",
      "Fund": "",
      "County": "Carson City",
      "Budget": 4928053.2,
      "OriginalPurchasePrice": 2500000,
      "OutOfPocket": 900000,
      "DisbursedAmount": 0,
      "NWCCProject": "Not Sent",
      "NumberOfUnits": 18,
      "OwnedOrPurchased": "LandOwned",
      "TPValuationDate": "2021-10-18T00:00:00",
      "TPValuationProviderId": "89be63df-19ad-47e1-84e4-aaa000aeea12",
      "TPValuationProvider": "52E23AEAFE72",
      "FloodZoneId": "7975a0fd-0fef-45b8-8dd7-a9e5014e1ab0",
      "FloodZone": "X",
      "ReadyForNWCC": false,
      "NWCCProjectId": "",
      "AutoDrawSetup": "No",
      "NeedsBorrowerApprovalBeforeSubmit": "No",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "NWCCProjectNo": "",
      "PortfolioManager": "Brittney Battrick",
      "IsBudgetFrozenYesNo": "No",
      "BudgetFrozenOn": "",
      "LoanSubStatus": "2nd Review",
      "LoanPhaseLoanStatusDisplayId": "Production - Processing - 2nd Review",
      "BudgetPercentComplete": 0,
      "AllUnitsPaidYesNo": "No",
      "LastestConstructionPhase": "",
      "DrawMgmt": "Draw Mgmt",
      "WorkInspectionCompany_OrganizationId": "",
      "LastInspectionCompanyUsed": "",
      "InspectionCompany": "",
      "PayoffStrategy": "Sell",
      "PayoffStrategyDescription": "",
      "Zoning": "",
      "NewPropertyType": "",
      "WorkStage": "",
      "EscrowReferenceNumber": "",
      "EscrowPay": "No",
      "Insurance": "Details",
      "CostBySquareFootage": "",
      "NextAutoDrawScheduleDate": "",
      "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D",
      "AdditionalCollateralDOTNumber": "",
      "AdditionalCollateralDOTRecorded": false,
      "ConvertedToNewPropertyOn": "",
      "ColorId": ""
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanDetailsBudget = () => {
  const mockData = [
    {
      "Id": "0dd1105a-fda9-4d0b-bec7-aed197d12270",
      "Display": "10/21/2021 - 3500100.00",
      "Borrower_OrganizationId": "1ed7e4a3-1b3d-450a-9707-979c1dcac602",
      "Borrower_Organization": "D6073D21B681",
      "LoanId": "348c5575-3b71-4284-b5e6-86c1111bcffb",
      "Loan": "72436 - E6D1E9C4AD83",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanBudgetTemplateId": "",
      "LoanBudgetTemplate": "",
      "Description": "",
      "CreatedOn": "2021-10-21T12:49:52.73",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-10-21T12:49:52.73",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "LoanBudgetStatus": "New",
      "FilterLoanId": "348c5575-3b71-4284-b5e6-86c1111bcffb",
      "FilterOrganizationId": "1ed7e4a3-1b3d-450a-9707-979c1dcac602",
      "Fund": "",
      "Owner": "Builders Capital",
      "Properties": "221E3883AE05",
      "CanDeleteId": "Yes",
      "IsBudgetFrozen": "No",
      "BudgetFrozenOn": "",
      "EscrowPay": "No",
      "FilterLoanOfficer_OrganizationContactCSVId": ",BF8B0038-8833-46D8-B355-AA1600B1DBEE,87CD2505-0480-427B-BD66-A6B300A18600,87CD2505-0480-427B-BD66-A6B300A18600,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanDetailsProposalCondition = () => {
  const mockData = [
    {
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "Id": "52cd4bb8-ad49-498a-99bb-005aa224e049",
      "LoanNumber": "72333",
      "ApplicationNumber": "2108060",
      "Borrower_Organization": "E79893E5B34E",
      "IsAutoAddedYesNo": "Yes",
      "EscrowInstruction": true,
      "ConditionStatus": "Received ",
      "ConditionTiming": "CO - Prior to Fund",
      "LoanConditionPhase": "",
      "Description": "deleted",
      "PortfolioManager": "Brittney Battrick",
      "LoanOfficer": "Alex LoanOfficer",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "LoanSubStatus": "2nd Review",
      "ProjectName": "DADDEC260C5A",
      "CreatedOn": "2021-08-16T12:24:48.257",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-30T16:15:55.493",
      "UpdatedBy": "deleted",
      "ConditionStatusId": "d9b9be0a-7eb4-4bd0-8b1c-acf4001b771b",
      "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
      "LoanConditionPhaseId": "",
      "Reason": "",
      "ExternalNotes": "",
      "Region": "",
      "Closer": "",
      "LoanProgram": "New Construction",
      "LoanSubType": "Refi-External",
      "CreditAnalyst": "Miranda Schwab",
      "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
      "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    },
    {
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "Id": "3c75c8a3-30c3-45c7-9a78-01077d397f83",
      "LoanNumber": "72333",
      "ApplicationNumber": "2108060",
      "Borrower_Organization": "E79893E5B34E",
      "IsAutoAddedYesNo": "Yes",
      "EscrowInstruction": true,
      "ConditionStatus": "Open",
      "ConditionTiming": "CO - Prior to Fund",
      "LoanConditionPhase": "",
      "Description": "deleted",
      "PortfolioManager": "Brittney Battrick",
      "LoanOfficer": "Alex LoanOfficer",
      "LoanPhase": "Production",
      "LoanStatus": "Processing",
      "LoanSubStatus": "2nd Review",
      "ProjectName": "DADDEC260C5A",
      "CreatedOn": "2021-08-16T12:24:48.257",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-08T17:54:41.667",
      "UpdatedBy": "deleted",
      "ConditionStatusId": "244fae56-1f02-4ff1-990b-acf4001b254a",
      "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
      "LoanConditionPhaseId": "",
      "Reason": "",
      "ExternalNotes": "",
      "Region": "",
      "Closer": "",
      "LoanProgram": "New Construction",
      "LoanSubType": "Refi-External",
      "CreditAnalyst": "Miranda Schwab",
      "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
      "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    }
  ];
  
  return getMockDataPromise(mockData);
};

const getMockLoanDetailsClosinConditions = () => {
   const mockData = [
     {
       "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "Id": "52cd4bb8-ad49-498a-99bb-005aa224e049",
       "LoanNumber": "72333",
       "ApplicationNumber": "2108060",
       "Borrower_Organization": "E79893E5B34E",
       "IsAutoAddedYesNo": "Yes",
       "EscrowInstruction": true,
       "ConditionStatus": "Received ",
       "ConditionTiming": "CO - Prior to Fund",
       "LoanConditionPhase": "",
       "Description": "deleted",
       "PortfolioManager": "Brittney Battrick",
       "LoanOfficer": "Alex LoanOfficer",
       "LoanPhase": "Production",
       "LoanStatus": "Processing",
       "LoanSubStatus": "2nd Review",
       "ProjectName": "DADDEC260C5A",
       "CreatedOn": "2021-08-16T12:24:48.257",
       "CreatedBy": "deleted",
       "UpdatedOn": "2021-09-30T16:15:55.493",
       "UpdatedBy": "deleted",
       "ConditionStatusId": "d9b9be0a-7eb4-4bd0-8b1c-acf4001b771b",
       "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
       "LoanConditionPhaseId": "",
       "Reason": "",
       "ExternalNotes": "",
       "Region": "",
       "Closer": "",
       "LoanProgram": "New Construction",
       "LoanSubType": "Refi-External",
       "CreditAnalyst": "Miranda Schwab",
       "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
       "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
     },
     {
       "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "Id": "3c75c8a3-30c3-45c7-9a78-01077d397f83",
       "LoanNumber": "72333",
       "ApplicationNumber": "2108060",
       "Borrower_Organization": "E79893E5B34E",
       "IsAutoAddedYesNo": "Yes",
       "EscrowInstruction": true,
       "ConditionStatus": "Open",
       "ConditionTiming": "CO - Prior to Fund",
       "LoanConditionPhase": "",
       "Description": "deleted",
       "PortfolioManager": "Brittney Battrick",
       "LoanOfficer": "Alex LoanOfficer",
       "LoanPhase": "Production",
       "LoanStatus": "Processing",
       "LoanSubStatus": "2nd Review",
       "ProjectName": "DADDEC260C5A",
       "CreatedOn": "2021-08-16T12:24:48.257",
       "CreatedBy": "deleted",
       "UpdatedOn": "2021-09-08T17:54:41.667",
       "UpdatedBy": "deleted",
       "ConditionStatusId": "244fae56-1f02-4ff1-990b-acf4001b254a",
       "ConditionTimingId": "2acee253-2acb-4335-bbc2-acf4001ca82f",
       "LoanConditionPhaseId": "",
       "Reason": "",
       "ExternalNotes": "",
       "Region": "",
       "Closer": "",
       "LoanProgram": "New Construction",
       "LoanSubType": "Refi-External",
       "CreditAnalyst": "Miranda Schwab",
       "LoanPhaseLoanStatusDisplay": "Production - Processing - 2nd Review",
       "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
     }
   ];

   return getMockDataPromise(mockData);
};

const getMockLoanDetailsEntities = () => {
   const mockData = [
     {
       "Id": "26f324d3-8c65-4602-9432-092ed1233cc4",
       "Description": "",
       "CreatedOn": "2021-08-25T15:37:56.137",
       "CreatedBy": "deleted",
       "UpdatedOn": "2021-08-25T15:37:56.137",
       "UpdatedBy": "deleted",
       "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "OrganizationId": "8a540c23-9acc-4cc8-b398-ad8f01018bcf",
       "SpecialPurposeEntityId": "",
       "Role": "Builder",
       "ProjectName": "DADDEC260C5A",
       "Organization": "81F5D581E9C4",
       "OrganizationContactId": "",
       "OrganizationContact": "",
       "ApplicationNumber": "2108060",
       "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
       "LoanNumber": "72333",
       "DetailEntered": "NA",
       "DetailEnteredColorId": "",
       "PreferredContactMethodOption": "",
       "BusinessRoles": "",
       "Borrower_Organization": "E79893E5B34E",
       "SpecialPurposeEntity": "",
       "EntityOption": "Loan",
       "Fund": "",
       "Email": "",
       "OfficePhone": "",
       "AffiliatedLoan": "",
       "GuarantyOption": "",
       "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
     },
     {
       "Id": "3068949b-6fb2-4576-8745-ad8600cc90f1",
       "Description": "",
       "CreatedOn": "2021-08-16T12:24:48.223",
       "CreatedBy": "deleted",
       "UpdatedOn": "2021-08-16T12:24:48.223",
       "UpdatedBy": "deleted",
       "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "OrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
       "SpecialPurposeEntityId": "",
       "Role": "Borrower Contact",
       "ProjectName": "DADDEC260C5A",
       "Organization": "E79893E5B34E",
       "OrganizationContactId": "c64a72bd-7b0c-44f8-a783-ad8600cc34c5",
       "OrganizationContact": "5EEDA3A84EE6 FEF7C4712BE7",
       "ApplicationNumber": "2108060",
       "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
       "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
       "LoanNumber": "72333",
       "DetailEntered": "NA",
       "DetailEnteredColorId": "",
       "PreferredContactMethodOption": "Email",
       "BusinessRoles": "Borrower Statement, Courtesy Reminders",
       "Borrower_Organization": "E79893E5B34E",
       "SpecialPurposeEntity": "",
       "EntityOption": "Loan",
       "Fund": "",
       "Email": "9EF757B17435@builders-capital.comold",
       "OfficePhone": "27",
       "AffiliatedLoan": "",
       "GuarantyOption": "",
       "FilterLoanOfficer_OrganizationContactCSVId": ",DB26BE0E-A05F-43D0-BAEF-AD660109F803,,,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
     }
   ];

   return getMockDataPromise(mockData);
};

const getMockLoanDetailsDocuments = () => {
  const mockData = [
    {
      "Id": "21e63cf7-5853-476b-be1e-adb000c756f2",
      "DocumentMasterId": "84e1e7dd-aab0-44f7-bedd-a6440137fee1",
      "DocumentMaster": "Appraisal",
      "Loans": "72351(Builders Capital)",
      "OrganizationId": "5f467fad-694b-48ab-a36c-eaf7b63da288",
      "Organization": "247E2B41AD33",
      "IsArchived": false,
      "DocumentFileName": "deleted",
      "EffectiveDate": "2021-09-27T00:00:00",
      "ExpiryDate": "2022-01-25T00:00:00",
      "Description": "deleted",
      "CreatedOn": "2021-09-27T12:05:46.573",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-27T12:05:46.573",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "Property": "",
      "FilterOrganizationId": "5f467fad-694b-48ab-a36c-eaf7b63da288",
      "ExpiryDateColorId": "pink",
      "LoanCompanyRestricted": false,
      "IncludeInLRCPolling": true,
      "Draws": "",
      "LoanId": "76fc24a9-175b-4761-b44e-3c161ed1d869"
    },
    {
      "Id": "30bcf547-582b-445b-982c-adb000c7165d",
      "DocumentMasterId": "f1575868-29ff-4f2b-8d10-ac5600638d74",
      "DocumentMaster": "Loan Proposal Global",
      "Loans": "72351(Builders Capital)",
      "OrganizationId": "5f467fad-694b-48ab-a36c-eaf7b63da288",
      "Organization": "247E2B41AD33",
      "IsArchived": false,
      "DocumentFileName": "deleted",
      "EffectiveDate": "2021-09-27T00:00:00",
      "ExpiryDate": "2021-10-27T00:00:00",
      "Description": "",
      "CreatedOn": "2021-09-27T12:04:51.31",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-27T12:04:51.31",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "Property": "",
      "FilterOrganizationId": "5f467fad-694b-48ab-a36c-eaf7b63da288",
      "ExpiryDateColorId": "pink",
      "LoanCompanyRestricted": true,
      "IncludeInLRCPolling": true,
      "Draws": "",
      "LoanId": "76fc24a9-175b-4761-b44e-3c161ed1d869"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanDetailsLoanHistory = () => {
  const mockData = {
    "success": true,
    "TransactionHistoryHtml": "<table class='htmlrecord htmlData'><tr style=\"font-weight:bold;background-color:lightblue\"><td>Trans Cat</td><td>Trans Type</td><td>Out Of Pocket</td><td>Charge/Pmt</td><td>Created On</td><td>Created By</td><td>Expect Pmt</td><td>Add To Ln Bal</td><td>Int Rate Hist</td><td>Trans Eff Date</td><td>C/W</td><td>Trans Amount</td><td>Running Balance</td><td>Owing Balance</td></tr><tr><td>Fees</td><td>Extension Fees</td><td></td><td>Charge</td><td></td><td style=\"text-align:center\">Built In</td><td style=\"text-align:center\">No</td><td style=\"text-align:center\">No</td><td style=\"text-align:right\"></td><td style=\"text-align:center\"></td><td style=\"text-align:center\"></td><td>$1,749.96</td><td>$1,749.96</td><td  style=\"text-align:right\"></td></tr></table>",
    "LoanAmountCurrent": null
  };

  return getMockDataPromise(mockData);
};

const getMockLoanDetailsComments = () => {
  const mockData = [
    {
      "Id": "cd23953d-2408-40fa-b998-adaa0183c207",
      "Borrower_OrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Borrower": "8CA0983C478C",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "LoanNumber": "72333",
      "CommentCategoryId": "c07e3f86-cf44-44b3-8df8-3900be34448c",
      "Category": "Production",
      "Subject": "LRC / Fund Polling",
      "OldCategory": "",
      "OldSubject": "",
      "Description": "deleted",
      "CreatedOn": "2021-09-21T23:31:47.067",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-21T23:31:47.067",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "GenerateEmail": false,
      "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Name": "B6CBA54FC231",
      "ApplicationNumber": "2108060",
      "ShowToNonLoanCompanyId": false,
      "Fund": "",
      "LoanDrawId": "",
      "PayoffRequestVersionNumber": "",
      "CommentCategorySubjectDisplayId": "Production - LRC / Fund Polling"
    },
    {
      "Id": "df47b843-ad5c-41f9-bad3-ada900df0559",
      "Borrower_OrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Borrower": "8CA0983C478C",
      "SpecialPurposeEntityId": "",
      "SpecialPurposeEntity": "",
      "LoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "LoanNumber": "72333",
      "CommentCategoryId": "c07e3f86-cf44-44b3-8df8-3900be34448c",
      "Category": "Production",
      "Subject": "LRC / Fund Polling",
      "OldCategory": "",
      "OldSubject": "",
      "Description": "deleted",
      "CreatedOn": "2021-09-20T13:31:59.793",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-20T13:31:59.793",
      "UpdatedBy": "deleted",
      "LockVersion": 0,
      "GenerateEmail": false,
      "FilterLoanId": "4981ec24-53cf-4da2-99b5-ad8600cc90d9",
      "FilterOrganizationId": "c1f585db-4948-465d-b83e-ad8600c8a7a1",
      "Name": "B6CBA54FC231",
      "ApplicationNumber": "2108060",
      "ShowToNonLoanCompanyId": false,
      "Fund": "",
      "LoanDrawId": "",
      "PayoffRequestVersionNumber": "",
      "CommentCategorySubjectDisplayId": "Production - LRC / Fund Polling"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanDetailsDraws = () => {
  const mockData = [];
  return getMockDataPromise(mockData);
};

const getMockLoanDetailsInspectionMessages = () => {
  const mockData = [];
  return getMockDataPromise(mockData);
};

const getMockLoanDetailsAssignments = () => {
  const mockData = [];
  return getMockDataPromise(mockData);
};

const getMockLoanUploadBudget = () => {
  const mockData = [];
  return getMockDataPromise(mockData);
};

const getMockLoanAssignments = () => {
  const mockData = [
    {
      "Id": "ffad647c-1596-4f1a-b4d4-1d54943c1bb7",
      "Display": "",
      "LoanId": "0e8044c7-d7ef-4321-96eb-d0dc52967662",
      "LoanNumber": "72654",
      "AssignmentTypeId": "774cb9b2-ece4-426b-bced-ac6400ad4dc3",
      "AssignmentType": "Initial",
      "Current_OrganizationId": "e9f6318d-47da-430d-b77d-ac1b00bb4506",
      "Current_Organization": "78C545416D09",
      "New_OrganizationId": "ce36171c-adf8-4273-b688-a9c90117d6f8",
      "New_Organization": "Builders Capital Investment LLC",
      "AssignmentOrder": 1,
      "TransferDate": "2022-03-18T00:00:00",
      "AssignmentCreatedYesNo": "No",
      "DotNumber": "deleted",
      "RecordingNumber": "",
      "RecordingDate": "",
      "FedexNumber": "",
      "FedexSentTo": "",
      "RequestToBeReturnedDate": "",
      "ReceivedAssetBackDate": "",
      "AssignmentNotRequiredYesNo": "No",
      "IsActive": true,
      "Description": "",
      "CreatedOn": "2022-03-21T15:09:09.31",
      "CreatedBy": "deleted",
      "UpdatedOn": "2022-03-21T15:09:09.31",
      "UpdatedBy": "deleted",
      "Borrower": "F6F09A530FE7",
      "SPE": "",
      "CreateAssignmentId": "Yes",
      "ProjectName": "60E238389D5D",
      "ParcelNumbers": "deleted"
    },
    {
      "Id": "69b9cb24-0db8-42e0-a105-d096065281c8",
      "Display": "",
      "LoanId": "6503b440-648a-49cf-bee0-d07f06957e53",
      "LoanNumber": "72498",
      "AssignmentTypeId": "a8329b45-9501-4219-a6e3-ac6400ad547a",
      "AssignmentType": "Loan Sale",
      "Current_OrganizationId": "070038eb-54e8-47b6-98e9-352a2731afc9",
      "Current_Organization": "Builders Capital",
      "New_OrganizationId": "f4c91cf8-a519-40b3-b652-adcb0084962e",
      "New_Organization": "Global 2021 Facility",
      "AssignmentOrder": 3,
      "TransferDate": "2022-03-21T00:00:00",
      "AssignmentCreatedYesNo": "No",
      "DotNumber": "deleted",
      "RecordingNumber": "",
      "RecordingDate": "",
      "FedexNumber": "",
      "FedexSentTo": "",
      "RequestToBeReturnedDate": "",
      "ReceivedAssetBackDate": "",
      "AssignmentNotRequiredYesNo": "Yes",
      "IsActive": true,
      "Description": "",
      "CreatedOn": "2022-03-21T13:56:17.56",
      "CreatedBy": "deleted",
      "UpdatedOn": "2022-03-21T13:56:17.56",
      "UpdatedBy": "deleted",
      "Borrower": "230458D31C93",
      "SPE": "",
      "CreateAssignmentId": "No",
      "ProjectName": "6372879812EF",
      "ParcelNumbers": "deleted"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockLoanAssignment = () => {
  const mockData = {
    "Id": "ffad647c-1596-4f1a-b4d4-1d54943c1bb7",
    "Display": "",
    "LoanId": "0e8044c7-d7ef-4321-96eb-d0dc52967662",
    "LoanNumber": "72654",
    "AssignmentTypeId": "774cb9b2-ece4-426b-bced-ac6400ad4dc3",
    "AssignmentType": "Initial",
    "Current_OrganizationId": "e9f6318d-47da-430d-b77d-ac1b00bb4506",
    "Current_Organization": "78C545416D09",
    "New_OrganizationId": "ce36171c-adf8-4273-b688-a9c90117d6f8",
    "New_Organization": "Builders Capital Investment LLC",
    "AssignmentOrder": 1,
    "TransferDate": "2022-03-18T00:00:00",
    "AssignmentCreatedYesNo": "No",
    "DotNumber": "deleted",
    "RecordingNumber": "",
    "RecordingDate": "",
    "FedexNumber": "",
    "FedexSentTo": "",
    "RequestToBeReturnedDate": "",
    "ReceivedAssetBackDate": "",
    "AssignmentNotRequiredYesNo": "No",
    "IsActive": true,
    "Description": "",
    "CreatedOn": "2022-03-21T15:09:09.31",
    "CreatedBy": "deleted",
    "UpdatedOn": "2022-03-21T15:09:09.31",
    "UpdatedBy": "deleted",
    "Borrower": "F6F09A530FE7",
    "SPE": "",
    "CreateAssignmentId": "Yes",
    "ProjectName": "60E238389D5D",
    "ParcelNumbers": "deleted"
  };

  return getMockDataPromise(mockData);
};

const getMockLoanAssignmentHtml = () => {
   const mockData = {
     "success": true,
     "AssignmentHistoryHtml": "<table class='htmlrecord htmlData'><tr><td  colspan=\"5\" style=\"text-align:center\"><h2>Previous Recording Detail</h2></td><tr style=\"font-weight:bold\"><td>Assignment Type</td><td>Current</td><td>New</td><td>Numbers</td><td>Date</td></tr><tr><td style=\"text-align:left\">1st</td><td style=\"text-align:left\">N/A</td><td style=\"text-align:left\"></td><td style=\"text-align:left\">deleted</td><td style=\"text-align:left\">03/18/2022</td></tr></table>"
   };

   return getMockDataPromise(mockData);
};

const getLoanAssignmentPreviousRecordingDetail = () => {
  const mockData = [
    {
      "AssignmentType": "1st",
      "Current": "N/A",
      "New": "",
      "Numbers": "deleted",
      "Date": "03/18/2022"
    }
  ];

  return getMockDataPromise(mockData);
};

const getLoanAssignmentRecordingDetail = () => {
  const mockData = [
    {
      "AssignmentType": "1st",
      "CurrentOrganization": "78C545416D09",
      "NewOrganization": "Builders Capital Investment LLC",
      "Recording Number": "",
      "Recording Date": ""
    }
  ];

  return getMockDataPromise(mockData);
};

const getLoanAssignmentDocumentLog = () => {
  const mockData = [];
  return getMockDataPromise(mockData);
};

const getMockOrganisationsInfoList = () => {
  const mockData = [
    {
      "id": "3d6e9328-de35-43f8-a2f6-45ea93e98c98",
      "organizationTypeId": "f70a6e55-31e4-4a01-9756-a60a00662447",
      "organizationType": "Vendor",
      "entitySubType": null,
      "name": "50159E675DAC",
      "abbreviation": null,
      "mailingCity": "Eagle",
      "mailingState": "Idaho",
      "mailingStreet": "0F0BDEE267F2",
      "mailingZipCode": "00612",
      "physicalCity": "Eagle",
      "physicalState": "Idaho",
      "physicalStreet": "86A646F7E06F",
      "physicalZipCode": "00662",
      "website": null,
      "isActive": true,
      "description": null,
      "createdOn": "2021-04-06T15:51:12.32",
      "createdBy": "deleted",
      "updatedOn": "2021-04-06T15:51:12.32",
      "updatedBy": "deleted",
      "comments": false,
      "filterOrganizationId": "3d6e9328-de35-43f8-a2f6-45ea93e98c98",
      "quickBooksFileName": null,
      "employerIdentificationNumber": null,
      "defaultBroker": false,
      "defaultBank": false,
      "mailingCounty": "Ada",
      "filterLoanOfficerOrganizationContactCsvid": null
    },
    {
      "id": "c825129c-5990-45f8-b3f9-209c472080d5",
      "organizationTypeId": "93318989-bdee-47a2-862f-a6b000a05d4a",
      "organizationType": "Brokerage",
      "entitySubType": "Limited Liability Company",
      "name": "CB1DBF1CC828",
      "abbreviation": null,
      "mailingCity": "Gilbert",
      "mailingState": "Arizona",
      "mailingStreet": "B0C8BF326E13",
      "mailingZipCode": "00612",
      "physicalCity": "Gilbert",
      "physicalState": "Arizona",
      "physicalStreet": "674A06D78DA8",
      "physicalZipCode": "00662",
      "website": null,
      "isActive": true,
      "description": null,
      "createdOn": "2021-12-14T12:09:07.27",
      "createdBy": "deleted",
      "updatedOn": "2021-12-14T12:09:07.27",
      "updatedBy": "deleted",
      "comments": false,
      "filterOrganizationId": "c825129c-5990-45f8-b3f9-209c472080d5",
      "quickBooksFileName": null,
      "employerIdentificationNumber": null,
      "defaultBroker": false,
      "defaultBank": false,
      "mailingCounty": "Arizona",
      "filterLoanOfficerOrganizationContactCsvid": null
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockOrganizationInfo = () => {
  const mockData = {
      "id": "3d6e9328-de35-43f8-a2f6-45ea93e98c98",
      "organizationTypeId": "f70a6e55-31e4-4a01-9756-a60a00662447",
      "organizationType": "Vendor",
      "entitySubType": null,
      "name": "50159E675DAC",
      "abbreviation": "Abbreviation Test",
      "mailingCity": "Eagle",
      "mailingState": "Idaho",
      "mailingStreet": "0F0BDEE267F2",
      "mailingZipCode": "00612",
      "physicalCity": "Eagle",
      "physicalState": "Idaho",
      "physicalStreet": "86A646F7E06F",
      "physicalZipCode": "00662",
      "website": null,
      "isActive": true,
      "description": null,
      "createdOn": "2021-04-06T15:51:12.32",
      "createdBy": "deleted",
      "updatedOn": "2021-04-06T15:51:12.32",
      "updatedBy": "deleted",
      "comments": false,
      "filterOrganizationId": "3d6e9328-de35-43f8-a2f6-45ea93e98c98",
      "quickBooksFileName": null,
      "employerIdentificationNumber": null,
      "defaultBroker": false,
      "defaultBank": false,
      "mailingCounty": "Ada",
      "filterLoanOfficerOrganizationContactCsvid": null
    };

  return getMockDataPromise(mockData);
};

const getMockOrganizationContacts = () => {
  const mockData = [
    {
      "Id": "a06f7f1a-33db-4de5-ae9e-000bee61d110",
      "SalutationId": "be1bd59e-1866-48fb-b66c-c0996e6d1f95",
      "Salutation": "Mr.",
      "FirstName": "3C2D9A2A4730",
      "LastName": "01CD0D6EC19E",
      "Email": "EFEB042170FD@builders-capital.comold",
      "OrganizationOwner": false,
      "PositionInCompany": "",
      "DateOfBirth": "",
      "Physical_Street": "8CD04AC1C4C9",
      "Physical_ZipCode": "00603",
      "Physical_StateId": "3424de84-8cf7-49ba-bf47-1edacd10be83",
      "Physical_State": "Unknown",
      "Physical_CityId": "2e581171-844e-4dd8-aa46-2f45cc1cc75d",
      "Physical_City": "Unknown",
      "Mailing_Street": "731CB264F4AE",
      "Mailing_ZipCode": "00646",
      "Mailing_StateId": "3424de84-8cf7-49ba-bf47-1edacd10be83",
      "Mailing_State": "Unknown",
      "Mailing_CityId": "2e581171-844e-4dd8-aa46-2f45cc1cc75d",
      "Mailing_City": "Unknown",
      "OfficePhone": "98",
      "OfficePhoneExtension": "",
      "MobilePhone": "",
      "HomePhone": "",
      "MLSNumber": "",
      "IsActive": true,
      "Description": "",
      "CreatedOn": "2021-08-04T15:43:37.023",
      "CreatedBy": "deleted",
      "UpdatedOn": "2021-09-27T09:31:26.477",
      "UpdatedBy": "deleted",
      "FilterOrganizationCSVId": "CA6858D8-DDAF-43DC-A249-3F4E2D402256,079D7E9D-F475-4F1C-98B6-AD7A016868D9,",
      "PreferredContactMethodOption": "Email",
      "DetailEntered": "Yes",
      "BusinessRoles": "Borrower Statement, Courtesy Reminders",
      "UserAccount": "EFEB042170FD@builders-capital.comold",
      "OrganizationCSV": "3779DBE9830C,B9449FC18AE5,",
      "OrganizationTypeCSV": "Borrower,",
      "OrganizationCSVId": "CA6858D8-DDAF-43DC-A249-3F4E2D402256,079D7E9D-F475-4F1C-98B6-AD7A016868D9,",
      "Tenant": "Builders Capital",
      "FilterLoanOfficer_OrganizationContactCSVId": "FDD0A017-665A-4F7E-8082-AD48009401C7,13082E46-5685-4E77-9BFA-A6E100552120,13082E46-5685-4E77-9BFA-A6E100552120,CE77F6B0-0244-48D9-84C9-A6B300A1AD4D"
    },
    {
      "Id": "0b322fea-2b6d-455a-baf5-003b0256c57d",
      "SalutationId": "be1bd59e-1866-48fb-b66c-c0996e6d1f95",
      "Salutation": "Mr.",
      "FirstName": "Scott",
      "LastName": "Pirrie",
      "Email": "systemadmin@builders-capital.com",
      "OrganizationOwner": true,
      "PositionInCompany": "deleted",
      "DateOfBirth": "1966-08-27T00:00:00",
      "Physical_Street": "09F355E9FC20",
      "Physical_ZipCode": "00603",
      "Physical_StateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "Physical_State": "Washington",
      "Physical_CityId": "95907021-4108-4da6-ad80-89b8bce7bac2",
      "Physical_City": "Seattle",
      "Mailing_Street": "589A22682312",
      "Mailing_ZipCode": "00646",
      "Mailing_StateId": "32ff61ff-31d2-4ab0-bcfb-2d88e7c9e21e",
      "Mailing_State": "Washington",
      "Mailing_CityId": "95907021-4108-4da6-ad80-89b8bce7bac2",
      "Mailing_City": "Seattle",
      "OfficePhone": "80",
      "OfficePhoneExtension": "",
      "MobilePhone": "",
      "HomePhone": "",
      "MLSNumber": "",
      "IsActive": true,
      "Description": "",
      "CreatedOn": "2017-03-31T13:09:27.48",
      "CreatedBy": "deleted",
      "UpdatedOn": "2017-04-19T10:03:49.62",
      "UpdatedBy": "deleted",
      "FilterOrganizationCSVId": "A7C0BC57-A7C7-4341-A7EB-F40DB87F055E,",
      "PreferredContactMethodOption": "Telephone",
      "DetailEntered": "No",
      "BusinessRoles": "Borrower Statement",
      "UserAccount": "",
      "OrganizationCSV": "3329A78A6846,",
      "OrganizationTypeCSV": "Borrower,",
      "OrganizationCSVId": "A7C0BC57-A7C7-4341-A7EB-F40DB87F055E,",
      "Tenant": "Builders Capital",
      "FilterLoanOfficer_OrganizationContactCSVId": ""
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockVotingP2Polling = () => {
  const mockData = [
    {
      "id": "18466812-694d-42e5-acdf-ab200127ff48",
      "projectName": "0F51322A3CE5",
      "borrower_OrganizationId": "22505acb-7000-4fa9-86c9-ab200110b4b5",
      "borrower_Organization": "55A120DDCB01",
      "specialPurposeEntityId": "",
      "specialPurposeEntity": "",
      "loanNumber": "71585",
      "description": "",
      "createdOn": "2019-12-11T17:57:41.82",
      "createdBy": "deleted",
      "updatedOn": "2021-08-04T12:48:29.707",
      "updatedBy": "deleted",
      "lockVersion": 76,
      "amountRequiredAtClosing": "",
      "additionalMortgage": "",
      "applicationNumber": "1912027",
      "filterLoanId": "18466812-694d-42e5-acdf-ab200127ff48",
      "loanPhaseId": "20105430-ed39-4e15-a4c8-a855006a6d4b",
      "loanStatusId": "a70092c6-cdad-4faf-927a-a855006a845e",
      "loanPhase": "Paid Off",
      "loanStatus": "Inactive",
      "loanSubStatus": "NA",
      "loanPhaseLoanStatusDisplayId": "Paid Off - Inactive - NA",
      "lockedBy_UserAccountId" :"",
      "perVoted": 100,
      "loanAmountOriginal": 2503253.2900,
      "fund": "F907BA98B4",
      "submittedDate": "",
      "directPay": false,
      "filterOrganizationId": "22505acb-7000-4fa9-86c9-ab200110b4b5"
    },
    {
      "id": "418d9a45-a0ac-4707-9d62-ab2101208b8b",
      "projectName": "2890CDFD33CC",
      "borrower_OrganizationId": "74989b60-ee60-4dc2-b68e-ab21011d1915",
      "borrower_Organization": "9C20F4353C76",
      "specialPurposeEntityId": "",
      "specialPurposeEntity": "",
      "loanNumber": "71596",
      "description": "",
      "createdOn": "2019-12-12T17:30:33.757",
      "createdBy": "deleted",
      "updatedOn": "2021-06-11T10:39:20.397",
      "updatedBy": "deleted",
      "lockVersion": 74,"AmountRequiredAtClosing": "",
      "additionalMortgage": "",
      "applicationNumber": "1912034",
      "filterLoanId": "418d9a45-a0ac-4707-9d62-ab2101208b8b",
      "loanPhaseId": "20105430-ed39-4e15-a4c8-a855006a6d4b",
      "loanStatusId": "a70092c6-cdad-4faf-927a-a855006a845e",
      "loanPhase": "Paid Off",
      "loanStatus": "Inactive",
      "loanSubStatus": "NA",
      "loanPhaseLoanStatusDisplayId": "Paid Off - Inactive - NA",
      "lockedBy_UserAccountId": "",
      "perVoted": 100,
      "loanAmountOriginal": 899520.0000,
      "fund": "F907BA98B4",
      "submittedDate": "",
      "directPay": false,
      "filterOrganizationId" :"74989b60-ee60-4dc2-b68e-ab21011d1915"
    },
    {
      "id": "ba0d2cba-3284-4e34-a22e-ab5e00d80dc2",
      "projectName": "0FF5D0F9F1AE",
      "borrower_OrganizationId": "6429f3ca-b2ae-436a-8ae8-ab5e00c20fb0",
      "borrower_Organization": "99BE8DB5C382",
      "specialPurposeEntityId": "",
      "specialPurposeEntity": "",
      "loanNumber": "71651",
      "description": "",
      "createdOn": "2020-02-11T13:06:37.827",
      "createdBy": "deleted",
      "updatedOn": "2021-04-05T12:48:20.157",
      "updatedBy": "deleted",
      "lockVersion": 78,
      "amountRequiredAtClosing": "",
      "additionalMortgage": "",
      "applicationNumber": "2002019",
      "filterLoanId": "ba0d2cba-3284-4e34-a22e-ab5e00d80dc2",
      "loanPhaseId": "20105430-ed39-4e15-a4c8-a855006a6d4b",
      "loanStatusId": "a70092c6-cdad-4faf-927a-a855006a845e",
      "loanPhase": "Paid Off",
      "loanStatus": "Inactive",
      "loanSubStatus": "NA",
      "loanPhaseLoanStatusDisplayId": "Paid Off - Inactive - NA",
      "lockedBy_UserAccountId": "",
      "perVoted": 100,
      "loanAmountOriginal": 832863.8100,
      "fund": "F907BA98B4",
      "submittedDate": "",
      "directPay": false,
      "filterOrganizationId": "6429f3ca-b2ae-436a-8ae8-ab5e00c20fb0"
    }
  ];

  return getMockDataPromise(mockData);
};

const getMockVotingP2PollingDocuments = () => {
  const mockData = [
    {
      "documentMaster": "Permits (if applicable)",
      "documentCategory": "Project",
      "documentName": "deleted.png",
      "Upload Date": "1/5/2021"
    },
    {
      "documentMaster": "Plat Map",
      "documentCategory": "Project",
      "documentName": "deleted.png",
      "Upload Date": "1/8/2021"
    },
    {
      "documentMaster": "Spec Sheets of Description of Materials",
      "documentCategory": "Project",
      "documentName": "deleted.png",
      "Upload Date": "1/28/2020"
    },
    {
      "documentMaster": "Building/Development Plans",
      "documentCategory": "Project",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Appraisal",
      "documentCategory": "Market Study",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Comparable Market Analysis (CMA)",
      "documentCategory": "Market Study",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Loan Proposal",
      "documentCategory": "Credit Review",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Proforma",
      "documentCategory": "Credit Review",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Credit Report",
      "documentCategory": "Guarantor",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "MLS Regression",
      "documentCategory": "Market Study",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "LRC Application",
      "documentCategory": "Application",
      "documentName": "deleted.png",
      "Upload Date": "12/20/2019"
    },
    {
      "documentMaster": "Proposed Plans",
      "documentCategory": "Project",
      "documentName": "deleted.png",
      "Upload Date": "1/28/2020"
    },
  ];
  return getMockDataPromise(mockData);
};
 
const getMockVotingP2PollingMembersVote = () => {
  const mockData = [
    {
      "member": "Robert Trent",
      "vote": "Approved",
      "date": "1/7/2021",
    },
    {
      "member": "Curt Altig",
      "vote": "Approved",
      "date": "1/7/2021",
    },
    {
      "member": "Robert Hadley",
      "vote": "Approved",
      "date": "1/6/2021",
    },
  ];
  return getMockDataPromise(mockData);
};

const getMockLoanDrawTemp = () => {
  return getMockDataPromise({});
};

const getMockLoanDrawTempDetails = () => {
  const mockData = {
    "additionalInspectionNeeded": false,
    "additionalInspectionApprovedByBorrower": null,
    "allDoNotOrderInspection": false,
    "allowedToUpdate": false,
    "bankInformationDisplay": null,
    "bankInformationId": null,
    "borrowerOrganizationDisplay": "9058B06878AE",
    "borrowerOrganizationId": "ae2de94f-85ce-4e2d-96dc-aadc009b3aea",
    "dateDownReceivedDate": null,
    "dateDownComment": null,
    "description": "deleted",
    "disableOrderDateDown": false,
    "disableOrderDrawInspection": false,
    "disableWaiveDateDown": false,
    "disableWaiveDrawInspection": false,
    "documentTempFileId": null,
    "drawInspectionComment": null,
    "drawHistory": false,
    "drawProcessingFee": 20,
    "escrowOfficer": "803B8B08C67B 5BD0BA6CD4AE",
    "escrowOfficerOrganizationContactId": "31726011-a2cc-41b4-8403-aa7700a4fab3",
    "escrowPay": false,
    "escrowReferenceNumber": null,
    "enterDrawWithoutInspectionComment": false,
    "excessApprovalPercentage": 0,
    "existingLoanDrawId": false,
    "inspectionDecision": null,
    "inspectionNotNeeded": false,
    "inspectionNotNeededDescription": null,
    "inspectionReceivedDate": null,
    "id": "e0180a6f-68bb-4182-8a82-1a91414aef13",
    "isApproveRequest": false,
    "isSendBackToBorrower": false,
    "isSubmitToBorrower": false,
    "isSubmitRequest": false,
    "loanDetailsDirectPay": false,
    "loanDisplay": "72433 - A988434F3BFD",
    "loanDrawName": null,
    "loanDrawHistoryId": null,
    "loanDrawId": null,
    "loanDrawStatusId": null,
    "loanDrawStatusDisplay": null,
    "loanId": "eb0f7857-53f9-4e9e-a74e-00422068fe5c",
    "loanPropertyDisplay": "11CB19222DE6",
    "loanPropertyId": "fc8ace91-c846-4952-a820-06c1fb88c37f",
    "maturityDateCurrent": "2022-10-14T00:00:00",
    "meetInspectorOnsite": false,
    "meetInspectorOnsiteDescription": null,
    "ninetyDaysAcc": -28443.05,
    "nwccProject": "Project ID: 1318",
    "pendingForInspection": "",
    "provideMoreDetail": false,
    "provideMoreDetailDescription": null,
    "provideMoreDetailOption": null,
    "revisionNumber": 0,
    "sendToBorrowerComment": null,
    "servicingComment": null,
    "showApprove": false,
    "sixtyDaysAcc": 0,
    "thirtyDaysAcc": 29530.64,
    "thirtyDaysDue": 29530.64,
    "titleNumber": "deleted",
    "vendorsCount": 0,
    "voidDraw": false,
    "watchListComment": null,
    "waiveDrawInspectionDate": null,
    "wireDateMessage": "Following documents are missing for Inspection Company. Do you need to upload?<br />Property 11CB19222DE6 is missing Building/Development Plans<br />\r\nProperty 11CB19222DE6 is missing Plat Map<br />\r\nProperty 11CB19222DE6 is missing Spec Sheets of Description of Materials<br />\r\nProperty 11CB19222DE6 is missing Site Plans for each Lot<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 11CB19222DE6 is missing Appraisal<br />\r\nProperty 45702764A66B is missing Building/Development Plans<br />\r\nProperty 45702764A66B is missing Plat Map<br />\r\nProperty 45702764A66B is missing Spec Sheets of Description of Materials<br />\r\nProperty 45702764A66B is missing Site Plans for each Lot<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 45702764A66B is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Building/Development Plans<br />\r\nProperty 3EF367CAE5F8 is missing Plat Map<br />\r\nProperty 3EF367CAE5F8 is missing Spec Sheets of Description of Materials<br />\r\nProperty 3EF367CAE5F8 is missing Site Plans for each Lot<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty 3EF367CAE5F8 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Building/Development Plans<br />\r\nProperty FC9A82F14074 is missing Plat Map<br />\r\nProperty FC9A82F14074 is missing Spec Sheets of Description of Materials<br />\r\nProperty FC9A82F14074 is missing Site Plans for each Lot<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />\r\nProperty FC9A82F14074 is missing Appraisal<br />",
    "loanComments": null,
    "loanDrawTempDetails": [
      {
        "budgetAmount": 2718,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 2582.1,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "c88708b0-7d6b-4140-8760-013084f33672",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-102500 - Fireplace / Chimney",
        "loanBudgetSubCategoryDisplay": "3826 - Fire Alarm",
        "loanBudgetDetailId": "fc0b92dc-36e6-43aa-83dc-1ef75d1b7578",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": 95,
        "sortOrder": 2500
      },
      {
        "budgetAmount": 11639.7,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 0,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "fb10c73b-a06a-4caa-8287-1a75c4ad4402",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-104400 - Hardwood Flooring",
        "loanBudgetSubCategoryDisplay": "4310 - Flooring",
        "loanBudgetDetailId": "65445266-3ea3-4f00-8b85-7249014d78f0",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": null,
        "sortOrder": 4500
      },
      {
        "budgetAmount": 10921,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 10921,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "c2028500-fbbc-4b99-a68f-1e51c5462bad",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-102400 - Roofing",
        "loanBudgetSubCategoryDisplay": "3810 - Roofing",
        "loanBudgetDetailId": "920800c3-a9dd-4b0b-ac63-2e6e36f2c32d",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": 100,
        "sortOrder": 2200
      },
      {
        "budgetAmount": 5800,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 5800,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "2fe565a7-c9b7-468f-b572-3112a6ea75bd",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-101300 - Excavation, Grade, Fill",
        "loanBudgetSubCategoryDisplay": "3440 - Excavation",
        "loanBudgetDetailId": "88954003-5c9f-4455-9ca0-bb7b05ecee42",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": 100,
        "sortOrder": 600
      },
      {
        "budgetAmount": 2500,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 0,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "f33d5720-72ba-44d0-943f-3248066a21d6",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-101300 - Excavation, Grade, Fill",
        "loanBudgetSubCategoryDisplay": "3470 - Fine Grade",
        "loanBudgetDetailId": "12441942-03f0-4328-aeb5-bf9f6f9c2580",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": null,
        "sortOrder": 800
      },
      {
        "budgetAmount": 3362,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 0,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "ad1ee8f5-58ac-4721-9540-3320631d4749",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-104900 - Mirrors & Shower Doors",
        "loanBudgetSubCategoryDisplay": "3955 - Shower Doors & Mirrors",
        "loanBudgetDetailId": "d8685368-0acf-46a8-9f08-50d93e3d50df",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": null,
        "sortOrder": 4800
      },
      {
        "budgetAmount": 1375,
        "description": null,
        "detailDirectPay": false,
        "directPay": false,
        "disbursedAmount": 0,
        "drawReference": null,
        "drawRequestedAmount": null,
        "id": "de47e550-d7ce-478d-8263-3c60c725934a",
        "isPaid": false,
        "isSelected": false,
        "loanBudgetCategoryDisplay": "R-102600 - HVAC",
        "loanBudgetSubCategoryDisplay": "3835 - Furnace Cleaning",
        "loanBudgetDetailId": "daffb4c0-08f4-4409-ad22-2170ad6d544e",
        "paidVendorName": null,
        "payeeOrganizationDisplay": null,
        "payeeOrganizationId": null,
        "paymentMethodOption": "ACH",
        "percentWorkComplete": null,
        "sortOrder": 2900
      }
    ],
    "loanDrawTempBudgetDetails": []
  };
  return getMockDataPromise(mockData);
};


const getMockViewOptionsSample = () => {
  const mockData = [
    {
      id: "0bf8dfcc-3bb8-445f-97ae-11af3b26ebdf",
      display: "Text Default",
      columns: "[{\"field\":\"Id\"},{\"field\":\"Name\",\"hidden\":true},{\"field\":\"Bank_Organization\"},{\"field\":\"Fund_Organization\"},{\"field\":\"AdvancePercentage\"},{\"field\":\"LoanFee\"},{\"field\":\"LOCAmount\"},{\"field\":\"EffectiveDate\"},{\"field\":\"ExpiryDate\"},{\"field\":\"LOCEstablishedDate\"},{\"field\":\"IsActive\"},{\"field\":\"Description\",\"hidden\":true},{\"field\":\"CreatedOn\"},{\"field\":\"CreatedBy\"},{\"field\":\"UpdatedOn\"},{\"field\":\"UpdatedBy\"},{\"field\":\"CashOnHand\"},{\"field\":\"CashOnHandEffectiveDate\"},{\"field\":\"LOCRate\"},{\"field\":\"LOCRateEffectiveDate\"}]",
      filters: "{\"filters\":[{\"logic\":\"or\",\"filters\":[{\"field\":\"IsActive\",\"operator\":\"eq\",\"value\":true}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"ExpiryDate\",\"operator\":\"gte\",\"value\":\"7/5/2021 12:00:00 AM\"},{\"field\":\"ExpiryDate\",\"operator\":\"lte\",\"value\":\"12/25/2022 12:00:00 AM\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"Bank_Organization\",\"operator\":\"contains\",\"value\":\"ba\"},{\"field\":\"Bank_Organization\",\"operator\":\"endswith\",\"value\":\"nk\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"LoanFee\",\"operator\":\"gt\",\"value\":1},{\"field\":\"LoanFee\",\"operator\":\"lt\",\"value\":10000}]}],\"logic\":\"and\"}",
      groups: "[{\"field\":\"Bank_Organization\",\"dir\":\"asc\"},{\"field\":\"Fund_Organization\",\"dir\":\"asc\"}]",
      sort: "[{\"field\":\"Bank_Organization\",\"dir\":\"desc\"}]",
      pageSize: 15,
      isSystem: true,
      isDefault: true,
      isWidthSaved: true
    },
    {
      id: "1238dfcc-3bb8-445f-97ae-11af3b26ebdf",
      display: "Default",
      columns: "[{\"field\":\"Id\"},{\"field\":\"Name\",\"hidden\":true},{\"field\":\"ExpiryDate\"},{\"field\":\"CreatedBy\"},{\"field\":\"Bank_Organization\",\"hidden\":true},{\"field\":\"Fund_Organization\"},{\"field\":\"IsActive\"},{\"field\":\"AdvancePercentage\"},{\"field\":\"LoanFee\"},{\"field\":\"LOCAmount\"},{\"field\":\"EffectiveDate\"},{\"field\":\"LOCEstablishedDate\"},{\"field\":\"Description\",\"hidden\":true},{\"field\":\"CreatedOn\"},{\"field\":\"UpdatedOn\"},{\"field\":\"UpdatedBy\"},{\"field\":\"CashOnHand\"},{\"field\":\"CashOnHandEffectiveDate\"},{\"field\":\"LOCRate\"},{\"field\":\"LOCRateEffectiveDate\"}]",
      filters: "{\"filters\":[{\"logic\":\"or\",\"filters\":[{\"field\":\"isActive\",\"operator\":\"eq\",\"value\":true}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"expiryDate\",\"operator\":\"gte\",\"value\":\"7/5/2021 12:00:00 AM\"},{\"field\":\"expiryDate\",\"operator\":\"lte\",\"value\":\"12/25/2022 12:00:00 AM\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"bankOrganization\",\"operator\":\"doesnotcontain\",\"value\":\"Test\"},{\"field\":\"bankOrganization\",\"operator\":\"endswith\",\"value\":\"t\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"fundOrganization\",\"operator\":\"contains\",\"value\":\"ca\"},{\"field\":\"fundOrganization\",\"operator\":\"isnotnull\",\"value\":\"LLC\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"effectiveDate\",\"operator\":\"gt\",\"value\":\"5/10/2022 12:00:00 AM\"},{\"field\":\"effectiveDate\",\"operator\":\"lte\",\"value\":\"12/29/2022 12:00:00 AM\"}]}],\"logic\":\"and\"}",
      groups: "[{\"field\":\"EffectiveDate\",\"dir\":\"asc\",\"aggregates\":[]}]",
      sort: "[{\"field\":\"Fund_Organization\",\"dir\":\"asc\"}]",
      pageSize: 15,
      isSystem: true,
      isDefault: false,
      isWidthSaved: true
    },
    {
      id: "0bf8dfcc-3bb8-445f-97ae-b4af3b26ebdf",
      display: "Custom Test",
      columns:
        [
          { "field": "applicationNumber", "width": 89 },
          { "field": "loanNumber", "width": 89, "hidden": true }
        ],
      filters: "{\"filters\":[{\"logic\":\"or\",\"filters\":[{\"field\":\"isActive\",\"operator\":\"eq\",\"value\":true}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"bankOrganization\",\"operator\":\"doesnotcontain\",\"value\":\"q\"},{\"field\":\"bankOrganization\",\"operator\":\"isempty\",\"value\":\"\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"fundOrganization\",\"operator\":\"iscontainedin\",\"value\":\"q\"},{\"field\":\"fundOrganization\",\"operator\":\"isnotnull\",\"value\":\"LLC\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"expiryDate\",\"operator\":\"gte\",\"value\":\"7/5/2021 12:00:00 AM\"},{\"field\":\"expiryDate\",\"operator\":\"lte\",\"value\":\"12/25/2022 12:00:00 AM\"}]},{\"logic\":\"or\",\"filters\":[{\"field\":\"effectiveDate\",\"operator\":\"isnull\",\"value\":\"12/7/2022 12:00:00 AM\"},{\"field\":\"effectiveDate\",\"operator\":\"gt\",\"value\":\"12/29/2022 12:00:00 AM\"}]}],\"logic\":\"and\"}",
      groups: ["field1", "field2"],
      sort: [
        { "field": "id" },
        { "field": "name", "descending": "true" }
      ],
      pageSize: 15,
      isSystem: true,
      isDefault: false,
      isWidthSaved: true
    },
  ];
  return getMockDataPromise(mockData);
};

export {
  getMockLoans,
  getMockLoan,
  getMockLoanApplications,
  getMockLoanApplicationsInfo,
  getMockLoanApplicationsProperty,
  getMockLoanApplicationsEntities,
  getMockLoanApplicationsComments,
  getMockLoanApplicationsCondition,
  getLoanStatusHistory,
  getLoanDetailsPropertyData,
  getMockLoanDetailsBudget,
  getMockLoanDetailsProposalCondition,
  getMockLoanDetailsClosinConditions,
  getMockLoanDetailsEntities,
  getMockLoanDetailsDocuments,
  getMockLoanDetailsLoanHistory,
  getMockLoanDetailsComments,
  getMockLoanDetailsDraws,
  getMockLoanDetailsInspectionMessages,
  getMockLoanDetailsAssignments,
  getMockLoanUploadBudget,
  getMockLoanAssignments,
  getMockLoanAssignment,
  getMockLoanAssignmentHtml,
  getLoanAssignmentPreviousRecordingDetail,
  getLoanAssignmentRecordingDetail,
  getLoanAssignmentDocumentLog,
  getMockOrganisationsInfoList,
  getMockOrganizationInfo,
  getMockOrganizationContacts,
  getMockVotingP2Polling,
  getMockVotingP2PollingDocuments,
  getMockVotingP2PollingMembersVote,
  getMockLoanDrawTemp,
  getMockLoanDrawTempDetails,
  getMockViewOptionsSample
};
